// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './Container.scss';
import { observable } from 'mobx';
import Request from '../../../api/Request';
import Card from './Card/Card';
import CircleLoader from '../../Util/CircleLoader/CircleLoader';
import Button from '../../Util/Button/Button';
import Subscriber from '../../../api/Subscriber';

@observer class Container extends Component<any, any> {

	@observable questions: any[] = [];

	steps: number = 5;
	currentPosition: number = 0;

	@observable empty: boolean = false;

	@observable loading: boolean = true;

	@observable lastComments: any = {};

	subscriber = new Subscriber();

	constructor(props: any) {
		super(props);
		this.fetch = this.fetch.bind(this);
		this.more = this.more.bind(this);
		this.handleCreateSubscriberMessage = this.handleCreateSubscriberMessage.bind(this);
		this.handleUpdateSubscriberMessage = this.handleUpdateSubscriberMessage.bind(this);

		this.subscriber.addTopic('/questions', 'question_create', this.handleCreateSubscriberMessage);
	}

	componentDidMount() {
		this.fetch();
	}

	componentWillUnmount() {
		this.subscriber.unsubscribe();
	}

	handleCreateSubscriberMessage(response: any) {
		this.questions = [
			response['@question'],
			...this.questions
		]
	}

	handleUpdateSubscriberMessage(response: any, index: number) {
		if (response['@comment']) {
			this.lastComments[index] = response['@comment'];
		} 

		this.questions[index] = response['@question'];
	}

	fetch(): void {
		if(!this.empty) {
			Request.get('/questions?orderBy[createdAt]=DESC&offset=' + this.currentPosition + '&limit=' + this.steps, {}).then((response) => {
				if (!response.status) {
					if (response.length === this.steps) {
						this.questions = [...this.questions, ...response];
					} else {
						if(response.length < this.steps) {
							this.questions = [...this.questions, ...response];
						}
						this.empty = true;
					}

					this.questions.forEach((question, index) => {
						this.subscriber.addTopic('/questions/' + question.id, 'question_update_' + question.id, (response: any) => this.handleUpdateSubscriberMessage(response, index))
					});

					this.subscriber.subscribe();
					this.loading = false;
				}
			});
		}
	}

	more(): void {
		this.subscriber.unsubscribe();
		this.subscriber.addTopic('/questions', 'question_create', this.handleCreateSubscriberMessage);
		this.loading = true;
		this.currentPosition += this.steps;
		this.fetch();
	}

	render() {
		return (
			<div className="question-list">
				{this.questions.length > 0 ? 
					this.questions.map((question, index) => {
						return (<Card 
							key={index} 
							question={question} 
							lastComment={this.lastComments[index] ? this.lastComments[index] : null} />)
					}) 
					: 
					<CircleLoader size={80}/>
				}
				{!this.empty && this.questions.length > 0 ? <Button loading={this.loading} text='More' onClick={this.more} /> : null}
			</div>
		)
	}
}

export default Container;

